import type { App } from 'vue';

import Loading from './loading';
import PtAffix from './affix';
import PtAlert from './alert';
import PtAutocomplete from './autocomplete';
import PtAvatar from './avatar';
import PtBacktop from './backtop';
import PtBreadcrumb from './breadcrumb';
import PtBreadcrumbItem from './breadcrumb-item';
import PtButton from './button';
import PtButtonGroup from './button-group';
import PtButtonV2 from './buttonv2';
import PtCard from './card';
import PtCheckbox from './checkbox';
import PtCheckboxButton from './checkbox-button';
import PtCheckboxGroup from './checkbox-group';
import PtCol from './col';
import PtCollapse from './collapse';
import PtCollapseItem from './collapse-item';
import PtCollapseTransition from './collapse-transition';
import PtDatePicker from './date-picker';
import PtDialog from './dialog';
import PtDialogV2 from './dialogV2';
import PtDrawer from './drawer';
import PtDropdown from './dropdown';
import PtDropdownItem from './dropdown-item';
import PtDropdownMenu from './dropdown-menu';
import PtForm from './form/index';
import PtFormItem from './form-item';
import PtIcon from './icon';
import PtInput from './input';
import PtInputNumber from './input-number';
import PtLink from './link';
import PtMessage from './message';
import PtMultiSelect from './multi-select';
import PtOption from './option';
import PtOptionGroup from './option-group';
import PtPagination from './pagination';
import PtPopover from './popover';
import PtPopper from './popper';
import PtProgress from './progress';
import PtRadio from './radio/index';
import PtRadioButton from './radio-button/index';
import PtRadioGroup from './radio-group/index';
import PtRow from './row';
import PtScrollbar from './scrollbar';
import PtSelect from './select';
import PtSkeleton from './skeleton';
import PtSkeletonItem from './skeleton-item';
import PtSlider from './slider';
import PtSortable from './sortable';
import PtSpace from './space';
import PtSwitch from './switch/index';
import PtTable from './table';
import PtTabPane from './tab-pane/index';
import PtTabs from './tabs';
import PtTag from './tag';
import PtTimePicker from './time-picker';
import PtTimeSelect from './time-select';
import PtTooltip from './tooltip';
import PtTour from './tour';
import PtTourStep from './tour-step';
import PtTree from './tree';
import PtUpload from './upload';
import PtVirtualized from './virtualized';

// import PtCascader from './cascader';
// import PtCascaderPanel from './cascader-panel';

import type { InstallOptions } from '../utils/config';
import { setConfig } from '../utils/config';

const components = [
    PtDrawer,
    PtAffix,
    PtAlert,
    PtAutocomplete,
    PtAvatar,
    PtBacktop,
    PtBreadcrumb,
    PtBreadcrumbItem,
    PtButton,
    PtButtonGroup,
    PtButtonV2,
    PtCard,
    PtCheckbox,
    PtCheckboxButton,
    PtCheckboxGroup,
    PtCol,
    PtCollapse,
    PtCollapseItem,
    PtCollapseTransition,
    PtDatePicker,
    PtDialog,
    PtDialogV2,
    PtDropdown,
    PtDropdownItem,
    PtDropdownMenu,
    PtForm,
    PtFormItem,
    PtIcon,
    PtInput,
    PtInputNumber,
    PtLink,
    PtMessage,
    PtMultiSelect,
    PtOption,
    PtOptionGroup,
    PtPagination,
    PtPopover,
    PtPopper,
    PtProgress,
    PtRadio,
    PtRadioButton,
    PtRadioGroup,
    PtRow,
    PtScrollbar,
    PtSelect,
    PtSkeleton,
    PtSkeletonItem,
    PtSlider,
    PtSortable.PtSortableContainer,
    PtSortable.PtSortableDraggable,
    PtSpace,
    PtSwitch,
    PtTable,
    PtTabPane,
    PtTabs,
    PtTag,
    PtTimePicker,
    PtTimeSelect,
    PtTooltip,
    PtTour,
    PtTourStep,
    PtTree,
    PtUpload,
    PtVirtualized,
    // PtCascader,
    // PtCascaderPanel,
];

const defaultInstallOpt: InstallOptions = {
    size: '' as ComponentSize,
    zIndex: 2000,
};

const install = (app: App, opt?: InstallOptions): void => {
    const option = Object.assign(defaultInstallOpt, opt || {});
    setConfig(option);

    components.forEach((component) => {
        app.component(component.name, component);
    });

    Loading.install(app);

    app.config.globalProperties.$tours = {};
    app.config.globalProperties.$ELEMENT = option;
    app.config.globalProperties.$loading = Loading.service;
};

export default {
    install,
};
